import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from '../icons';

// Drawer laterale destro, autosufficiente come Modal: inietta i propri stili una
// volta sola (token del design system), si renderizza in un portal su
// document.body per stare sopra topbar e card con backdrop-filter, e chiude con
// Esc, click sul backdrop o sulla X. Va montato solo quando aperto (entrata
// animata; niente animazione d'uscita, come le altre superfici del pannello).
const STYLE_ID = 'drawer-styles';
const CSS = `
.drawer-backdrop {
  position: fixed; inset: 0; z-index: 60; display: flex; justify-content: flex-end;
  background: rgba(8, 10, 18, .5);
  backdrop-filter: blur(3px); -webkit-backdrop-filter: blur(3px);
  animation: drawer-fade .18s ease;
}
.drawer-panel {
  width: min(440px, 100%); height: 100%; display: flex; flex-direction: column;
  background: var(--bg-glass-strong);
  backdrop-filter: blur(var(--blur)); -webkit-backdrop-filter: blur(var(--blur));
  border-left: 1px solid var(--border-default);
  box-shadow: -24px 0 64px var(--shadow-color);
  animation: drawer-slide .3s cubic-bezier(0.16, 1, 0.3, 1);
}
.drawer-head {
  display: flex; align-items: center; gap: .55rem;
  padding: 1.1rem 1.35rem; border-bottom: 1px solid var(--border-default); flex-shrink: 0;
}
.drawer-head .icon { color: var(--hiplaas-orange); }
.drawer-head h3 { margin: 0; font-size: 1.05rem; font-weight: 700; color: var(--text-primary); }
.drawer-head .drawer-close { margin-left: auto; }
.drawer-body { padding: 1.35rem; overflow-y: auto; flex: 1; }
/* Form impilato verticalmente dentro il drawer (a differenza di .inline-form). */
.drawer-form .field { margin-bottom: 1.1rem; }
.drawer-form .combobox, .drawer-form .select-wrap { width: 100%; }
.drawer-form .btn[type="submit"] { width: 100%; margin-top: 1.35rem; }
@keyframes drawer-fade { from { opacity: 0; } to { opacity: 1; } }
@keyframes drawer-slide { from { transform: translateX(100%); } to { transform: translateX(0); } }
`;

function ensureStyles() {
  if (typeof document === 'undefined' || document.getElementById(STYLE_ID)) return;
  const s = document.createElement('style');
  s.id = STYLE_ID;
  s.textContent = CSS;
  document.head.appendChild(s);
}

function Drawer({ title, icon, onClose, children }) {
  useEffect(ensureStyles, []);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div className="drawer-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <aside className="drawer-panel" role="dialog" aria-modal="true" aria-label={title}>
        <div className="drawer-head">
          {icon && <Icon name={icon} size={18} />}
          <h3>{title}</h3>
          <button type="button" className="icon-btn drawer-close" aria-label="Chiudi" onClick={onClose}>
            <Icon name="x" size={16} />
          </button>
        </div>
        <div className="drawer-body">{children}</div>
      </aside>
    </div>,
    document.body
  );
}

export default Drawer;
